<template>
  <v-row no-gutters>
    <feature-card-basic ref="featureCard" @update:feature="featureFetched" :layer="layer">
      <template #top v-if="!isNewFeature">
        <sidebar-form-row :value="addressValue" v-bind="addressRowData" icon="mdi-map-marker" />
        <sidebar-row border-top border-bottom class="pr-5" v-if="canBrowse">
          <widget-partitions-watermeters-wrapper class="py-5" :partition-id="fid" :can-edit="canEdit">
          </widget-partitions-watermeters-wrapper>
        </sidebar-row>
      </template>
    </feature-card-basic>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';

import FeatureCardBasic from '@/components/FeatureCardBasic';
import SidebarRow from '@/components/SidebarRow';
import SidebarFormRow from '@/components/SidebarFormRow';

export default {
  name: 'FeatureCardPartition',
  components: {
    SidebarFormRow,
    SidebarRow,
    FeatureCardBasic,
    WidgetPartitionsWatermetersWrapper: () => import('@/components/WidgetPartitionsWatermetersWrapper'),
  },
  props: {
    layer: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    feature: undefined,
  }),
  computed: {
    addressRowData() {
      return {
        name: 'address',
        dataType: {
          name: 'text',
        },
        translationPath: 'sidebar.address',
      };
    },
    addressNumberValue() {
      const { address_order, address_local } = this.feature?.properties || {};
      if (address_order && address_local) {
        return `${address_order}/${address_local}`;
      } else if (address_order) {
        return `${address_order}`;
      }
      return '';
    },
    addressValue() {
      const { address_place, address_street } = this.feature?.properties || {};
      if (address_place && address_street) {
        return `ul. ${address_street} ${this.addressNumberValue}, ${address_place}`;
      } else if (address_street) {
        return `ul. ${address_street} ${this.addressNumberValue}`;
      }
      return '';
    },
    isNewFeature() {
      return this.fid === 'new';
    },
    fid() {
      return this.$route.params.fid;
    },
    watermetersLayerId: get('admin/modulesMapping@billing.layer_id'),
    partitionsLayerId: get('admin/modulesMapping@billing.partitions_layer_id'),
    toolsPermissons: get('users/toolsPermissions'),
    billingsPermissions() {
      return this.toolsPermissons?.['BILLINGS']?.main_value;
    },
    canBrowseBillings() {
      return this.billingsPermissions > 0;
    },
    canEditBillings() {
      return this.billingsPermissions > 1;
    },
    watermetersPermissions: get('users/layersPermissions@:watermetersLayerId.main_value'),
    partitionsPermissions: get('users/layersPermissions@:partitionsLayerId.main_value'),
    canEditPartitions() {
      return this.partitionsPermissions > 1;
    },
    canEditWatermeters() {
      return this.watermetersPermissions > 1;
    },
    canBrowsePartitions() {
      return this.partitionsPermissions > 0;
    },
    canBrowseWatermeters() {
      return this.watermetersPermissions > 0;
    },
    canBrowse() {
      return this.canBrowseBillings && this.canBrowsePartitions && this.canBrowseWatermeters;
    },
    canEdit() {
      return this.canEditBillings && this.canEditPartitions && this.canEditWatermeters;
    },
  },
  methods: {
    featureFetched(feature) {
      this.feature = feature;
    },
  },
};
</script>

<style lang="scss" scoped>
.box--border {
  @include border(bottom);
}
</style>
